import "../../global.css";
import { Platform } from "@-/com.npmjs.react-native";
import { Root } from "@-/dev.improve.haniverse.routes";

export const unstable_settings = {
  // `/` is a lightweight platform entry route. Native forwards into `(nav)/startup`, while web
  // forwards to the marketing page without mounting the app/database navigator.
  //
  // WEB (SSR): anchoring the root stack to `index` made the SERVER render the marketing page for
  // EVERY url — React Navigation seeds a stack from its initial route, so `/browse/morpheme/<g>`
  // server-rendered "Learn the logic inside Chinese characters" and the real page only appeared
  // after client hydration. That is invisible to crawlers (every route looked like the landing
  // page) and shows as a spinner to users. Web therefore takes no anchor and renders the
  // REQUESTED route; native keeps the anchor so its startup gate still owns the cold-launch path.
  anchor: Platform.OS === "web" ? undefined : "index",
};

export default function RootLayoutRoute() {
  return <Root />;
}
